import React, { memo, useEffect, useState } from 'react';
import styles from './Comment.module.less';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import MessageLine from '../MessageLine/MessageLine';
// import { deleteMessageHot } from '../../../actions/message';
import InfiniteScroll from 'react-infinite-scroller';
import { useCallback } from 'react';
import { getMessageList } from '../../../actions/message';

const selectMessage = createSelector(
  state => state.message,
  message => ({
    commentList: message.commentList || [],
    messageHot: message.hot,
    commentPagenation: message.commentPagenation,
    commentLoading: message.commentLoading,
  }),
);
export default memo(() => {
  const [node, setNode] = useState(null);
  const [commentIndex, setCommentIndex] = useState(-1);
  const dispatch = useDispatch();
  const {
    commentList,
    // messageHot,
    commentPagenation,
    commentLoading,
  } = useSelector(selectMessage);
  useEffect(() => {
    // if (messageHot && messageHot[1] === '1') {
    // dispatch(deleteMessageHot({ code: 1 }));
    // }
  }, []);

  const loadMore = useCallback(() => {
    if (!commentLoading) {
      dispatch(getMessageList({ code: 1, skip: commentList.length, limit: 24, refresh: false }));
    }
  });

  const handleCommentIndex = index => {
    setCommentIndex(index);
  };
  return (
    <div className={styles.comment} ref={r => setNode(r)}>
      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        hasMore={commentList.length < commentPagenation.count}
        loader={
          <div className="loader" key={0}>
            ----------加载中----------
          </div>
        }
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => node}
      >
        {commentList &&
          commentList.map((comment, index) => (
            <MessageLine
              message={comment}
              key={comment.id}
              setCommentIndexCallback={handleCommentIndex}
              commentIndex={commentIndex}
              orderIndex={index}
            />
          ))}
      </InfiniteScroll>
    </div>
  );
});
